import { injectable } from 'inversify';

@injectable()
export abstract class EntityBase {
  public Id: string = null;

  constructor() {
    if (this.Id === null) { this.Id = "00000000-0000-0000-0000-000000000000"; }
  }

  /**
   * Gets a value indicating whether the record is a new record
  */
  public get IsNew(): boolean { return this.Id === "00000000-0000-0000-0000-000000000000"; }

  /**
   * Assign the entity from the supplied data
  */
  protected Assign(data: any): void {
    if (data) {
      Object.assign(this, data);
    }
  }

  abstract toJSON(): any;
}